/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Valid values for a field-criterion field in a Query.
 */
export enum BioSampleCriteriaFieldsV1 {
    BIO_SAMPLE_ID = 'BIO_SAMPLE_ID',
    SAMPLE_CODE = 'SAMPLE_CODE',
    SAMPLE_KIT_CODE = 'SAMPLE_KIT_CODE',
    USER_ID = 'USER_ID',
    CREATED_AT = 'CREATED_AT',
    LAST_MODIFIED = 'LAST_MODIFIED',
    CREATED_BY = 'CREATED_BY',
    MODIFIED_BY = 'MODIFIED_BY',
    CONTAINER_DESCRIPTION = 'CONTAINER_DESCRIPTION',
    CUSTOM_STATUS_TYPE = 'CUSTOM_STATUS_TYPE',
    CUSTOM_STATUS_VALUE = 'CUSTOM_STATUS_VALUE',
    CUSTOM_STATUS_LOCAL_TIMESTAMP = 'CUSTOM_STATUS_LOCAL_TIMESTAMP',
    CUSTOM_STATUS_CREATED_BY = 'CUSTOM_STATUS_CREATED_BY',
    EVENT_ID = 'EVENT_ID',
    META_TYPE = 'META_TYPE',
    META_NAME = 'META_NAME',
    META_DESC = 'META_DESC',
    META_DATA = 'META_DATA',
    REFS_KEY = 'REFS_KEY',
    REFS_VALUE = 'REFS_VALUE',
    SCHEDULE_CODE = 'SCHEDULE_CODE',
    SCHEDULE_REQUEST_CODE = 'SCHEDULE_REQUEST_CODE',
    SCHEDULE_VERSION_CODE = 'SCHEDULE_VERSION_CODE',
}